<template>
    <div class="edit app-inner">
        <!-- <div class="edit-header flex align-cen">
            <el-button plain @click="reback">返回</el-button>
             <el-button type="primary" class="mft" @click="onSubmit('ruleForm')">{{edittext}}</el-button>
        </div> -->
          <div class="public-btn-small flex align-cen posta" style="padding-left:0;">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="onSubmit('ruleForm')"
            >
                {{edittext}}
            </el-button>
            </div>
        <div class="edit-from">
          <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
            <!-- <div class="edit-from-tit">基本信息</div> -->
            <el-form ref="ruleForm" :model="form" label-width="100px" :rules="rules" class="flex align-cen">
                <el-form-item label="企业名称：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入企业名称【0-30】" clearable></el-input>
                </el-form-item>
                 <el-form-item label="企业类型：" prop="classifyId">
                    <el-select v-model="form.classifyId" placeholder="请选择企业类型">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="企业电话：" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入企业电话 【座机：区号+电话号码】" clearable></el-input>
                </el-form-item>
                 <el-form-item label="企业网址：" >
                    <el-input placeholder="请输入企业网址" v-model="form.webSite">
                        <template slot="prepend">Http://</template>
                    </el-input>
                </el-form-item>
                 <el-form-item label="详细地址：" prop="province">
                    <el-cascader
                            size="large"
                            :options="options1"
                            v-model="selectedOptions"
                            @change="handleChange"
                            placeholder="请选择省/市/区"
                            clearable
                            >
                     </el-cascader>
                    <el-input v-model="form.address" placeholder="请输入详细地址【必填】" clearable style="margin-top:20px"></el-input>
                </el-form-item>
                  <el-form-item label="企业税号：" >
                    <el-input placeholder="请输入企业税号" v-model="form.taxId">
                    </el-input>
                </el-form-item>
                                   <el-form-item label="企业状态：" prop="state">
                    <el-select v-model="form.state" placeholder="请选择企业状态">
                        <el-option
                        v-for="item in options2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- -->
                 <el-form-item label="企业LOGO：">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :disabled="uploadBoolean"
                    :before-upload="$util.beforeUpload"
                    :on-error="upLoadError"
                    >
                    <img :src="form.logo" class="avatar" v-if="form.logo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                     <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">120*40</span></div>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :modal-append-to-body="false" :show-close="false">
                        <img width="100%" :src="form.logo" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
                         <el-form-item label="企业全称：" >
                    <el-input placeholder="请输入企业全称" v-model="form.fullName">
                    </el-input>
                </el-form-item>
                 <div class="public-tit flex align-cen" style="width:100%;margin-bottom:20px">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  关联账号信息
                    </div>
                </div>
                 <div class="businessList-filter-list flex align-cen">
                    <div class="label">选择企业：</div>
                    <div class="public-btn-small" style="padding-left:0"  @click="openBl">
                         <div class="public-btn-small-primary">选择管理员账号</div>
                    </div>
                </div>
            </el-form>
                            <div class="show-table" v-if="multipleSelection.length !=0">
                       <el-table
                    :data="multipleSelection"
                    ref="multipleTable"
                    tooltip-effect="dark"
                    style="width: 100%;margin-top:16px"
                    border
                    id='mytable'
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                     <!-- <el-table-column type="selection" width="55" reserve-selection> </el-table-column> -->
                       <el-table-column prop="id" label="管理员ID" align="center">
                        </el-table-column>
                         <el-table-column prop="userName" label="管理员姓名" align="center">
                        </el-table-column>
                         <el-table-column prop="loginName" label="管理员账号" align="center">
                        </el-table-column>
                           <el-table-column  label="关联微信号" align="center">
                            <template slot-scope="scope">
                                <div> {{scope.row.wechatAccount || '暂未关联'}}</div>
                            </template>
                        </el-table-column>
                         <el-table-column label="操作" align="center"
                          fixed="right"
                         >
                <el-button type="text" size="small"  style="color:red" @click="openBl(1)">更换</el-button>
          </el-table-column>
                  </el-table>
                </div>
        </div>
        <!-- 选择企业管理员弹窗 -->
             <el-dialog
  title="关联企业管理员"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  >
<div class="businessAdmin">
       <div class="p-tit-c">
        <div class="businessList-filter">
              <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">管理员ID：</div>
          <div class="el-select1">
            <el-input placeholder="管理员ID" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">管理员姓名：</div>
          <div class="el-select1">
          <el-input placeholder="管理员姓名" v-model="search1" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">管理员账号：</div>
          <div class="el-select1">
          <el-input placeholder="管理员账号" v-model="search2" clearable> </el-input>
          </div>
         </div>
      </div>
       <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="searchList">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
        </div>
       </div>
       <div class="businessList-container">
        <!-- 表格 -->
            <div class="businessList-container-table">
                  <el-table
                    :data="itemList"
                    tooltip-effect="dark"
                    style="width: 100%"
                    border
                    id='mytable'
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                     <!-- <el-table-column type="selection" width="55" reserve-selection> </el-table-column> -->
                       <el-table-column prop="id" label="管理员ID" align="center">
                        </el-table-column>
                         <el-table-column prop="userName" label="管理员姓名" align="center">
                        </el-table-column>
                         <el-table-column prop="loginName" label="管理员账号" align="center">
                        </el-table-column>
                          <el-table-column prop="businessNum" label="关联企业" align="center">
                        </el-table-column>
                         <el-table-column label="操作" align="center"
                          fixed="right"
                         >
                           <template slot-scope="scope">
                <el-button type="text" size="small"  style="color:red" @click.stop="relation(scope.row)">关联</el-button>
                           </template>
          </el-table-column>
                  </el-table>
                  <!-- 分页 -->
                    <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
            </div>
       </div>
</div>
 </el-dialog>
    </div>
</template>
<script>
import  Format from "../../../utils/auth.js"  
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import {getbusinesstypelist} from "@/api/index/index"  //企业分类
import {addbusiness} from "@/api/index/index" //新增企业
import { businessDetail } from "@/api/index/index" //详情
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import {getbusinessAccountList} from "@/api/index/index"  //企业管理员列表
export default {
	name: "editBusiness",
	 data: () => {
    return {
        loading:false,
        search:'',
        search1:'',
        search2:'',
        search3:'',
        multipleSelection:[],
        totalNum:0,
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        totalCount: 0,
        pageSizes:[10,20,30,40,50,100],
        itemList:[],
        form:{
            name:'',
            classifyId:'',
            phone:'',
            webSite:'',
            state:'',
            province:'',
            city:'',
            district:'',
            address:'',
            logo:'',
            taxId:'',
            fullName:''
        },
       centerDialogVisible:false,
        accountId:'',//账号id
        edittext:'保存',
        headers:{},
       edittype:0, //0新增 //1修改
        uploadBoolean:false,
        oploadDialogVisible: false,
        alladdress:'',
        options1: regionData,
        selectedOptions: [],
        options2:[
            {
          value: '0',
          label: '试用'
        }, {
          value: '1',
          label: '有意向',
        },{
          value: '2',
          label: '谈判',
        },{
          value: '3',
          label: '合作中',
        },{
          value: '4',
          label: '停止合作',
        }
        ],
       options: [],
        rules:{
              name: [
                     {
                        validator: Format.FormValidate.Form().APPName,   //validator： 自定义验证规则
                        trigger: "blur",
                        message:'请正确输入符合规则的企业名称',
                        required: true, 
                        }
                 ],
              classifyId: [{ required: true, message: '请选择企业类型', trigger: 'change' },],
              phone:[
                  {
                        validator: Format.FormValidate.Form().Phone,   //validator： 自定义验证规则
                        trigger: "blur",
                        message:'请输入正确号码!',
                        required: true, 
                        }
              ],
               province: [{ required: true, message: '请选择地址', trigger: 'change' },],
               state: [{ required: true, message: '请选择企业状态', trigger: 'change' },],
        }
	}
	},
  
	mounted(){
	},
    created(){
        this.getbusClass()
        let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        if(this.$route.query.id){
            this.$route.meta.title = "修改企业信息"
            this.edittext = "修改"
            this.getDetail()
        }else{
            this.$route.meta.title = "新增企业" 
             this.edittext = "保存"
        }
    },
	methods: {
        // 关联回显
            relation(data){
                var arr = [];
                arr.push(data)
              this.multipleSelection = arr
              this.accountId = arr[0].id
              this.centerDialogVisible = false
            },
           getRowKeyOfTarget(row) {
            return row.id
        },
                  // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
       handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
      // 重置
        reset(){
            this.search = ""
            this.search1 = ""
            this.search2 = ""
            this.search3 = ""
            this.currentPage = 1
            this.gethisInfo()
        },
      // 搜索
        searchList(){
             if(this.search || this.search1 || this.search2 || this.search3){
                this.currentPage = 1
                this.gethisInfo()
            }else{
               this.$message.warning('请输入查询条件'); 
            }
        },
                 // 获取企业管理员列表
        gethisInfo(){
            let params = {
                id:this.search,
                userName:this.search1,
                businessId:'',
                businessName:'',
                source:'',
                current: this.currentPage,
                size:this.PageSize,
                loginName:this.search2
                
            }
            getbusinessAccountList(params)
            .then(res => {
              this.itemList = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
        // 打开管理员账号
        openBl(type){
          if(type == 1){
           this.$confirm('更换管理员后, 该企业管理员信息将被替换，仍要继续吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              this.gethisInfo()
           this.centerDialogVisible = true
        }).catch(() => {         
        });
          }else{
                 this.gethisInfo()
           this.centerDialogVisible = true
          }
        },
        // 获取详情
        getDetail(){
              businessDetail({
                id:this.$route.query.id
              })
            .then(res => {
             this.form = {
                    name:res.data.name,
                    classifyId:res.data.classifyId,
                    phone:res.data.phone,
                    webSite:res.data.webSite,
                    state:res.data.state,
                    province:res.data.province,
                    city:res.data.city,
                    district:res.data.district,
                    address:res.data.address,
                    logo:res.data.logo,
                    taxId:res.data.taxId,
                    fullName:res.data.fullName
                }
             if(res.data.accountId){
                 this.multipleSelection = [
                    {
                        id:res.data.accountId,
                        userName:res.data.userName,
                        loginName:res.data.loginName,
                        wechatAccount:'',
                    }
                ]
             }
             this.accountId = res.data.accountId
             this.selectedOptions = [TextToCode[res.data.province].code, TextToCode[res.data.province][res.data.city].code, TextToCode[res.data.province][res.data.city][res.data.district].code]
            })
            .catch(err => {
            })
        },
        
        // 图片放大
         oploadImgPre(){
                this.oploadDialogVisible = true
            },
             oploadImgDel(){
                this.form.logo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
            },
           // 获取企业分类
        getbusClass(){
            getbusinesstypelist({})
            .then(res => {
              this.options = res.data
            })
            .catch(err => {
            })
        },
          handleAvatarSuccess(res, file) {
        this.form.logo = res.data.url
        
        if(this.form.logo){
        this.uploadBoolean = true
         }
      },
      // 图片上传失败钩子
      upLoadError(err){
        this.$message.error('图片上传失败')
      },
        handleChange (value) {
        if (value[1] != null && value[2] != null) {
        this.form.province = CodeToText[value[0]]
        this.form.city = CodeToText[value[1]]
        this.form.district = CodeToText[value[2]]
        this.alladdress = CodeToText[value[0]] +'-' + CodeToText[value[1]] + '-' + CodeToText[value[2]]
      } else {
        if (value[1] != null) {
             this.form.province = CodeToText[value[0]]
        this.form.city = CodeToText[value[1]]
         this.alladdress = CodeToText[value[0]] + '-' + CodeToText[value[1]]
        } else {
             this.form.province = CodeToText[value[0]]
          this.alladdress = CodeToText[value[0]]
        }
      }
      },
        onSubmit(formName){
		// 把 name 属性，放到对象中
		            let params = { ...this.form};
                    let method = "post"
                     if(!this.$route.query.id) params = {...this.form,accountId:this.accountId},method = "post"; 
                     if(this.$route.query.id) params = {...this.form,id:this.$route.query.id,accountId:this.accountId}, method = "put"; 
                    this.$refs[formName].validate((valid) => {
                        if(valid){
                            if(this.multipleSelection.length == 0) return this.$message.error('请选择关联管理员账号') 
                            this.commentBness(params,method)
                        }
                    })
        },
        commentBness(params,method){
               this.loading = true
                addbusiness(params,method)
                        .then(res => {
                          this.loading = false
                           if(res.code == 0){
                            if(!this.$route.query.id) this.$message.success('新增成功'); 
                           if(this.$route.query.id) this.$message.success('修改成功'); 
                                setTimeout(() => {
                           this.$router.push("/businessList")
                             }, 100);
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
        reback(){
            this.$router.push('/businessList')
        }
    }
}
</script>
<style lang="scss" scoped>
    .businessAdmin{
      .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
    }
.edit{
    height: inherit;
    .edit-header{
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        padding: 20px;

    }
    .edit-from{
       margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
         .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        }
         }
         .businessList-filter-list{
            .label::before{
                content: '*';
                color: red;
            }
         }

    }
}

  ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .el-dialog{
        width: 30%;
    }
  }
    // .edit{
    //     width: 100%;
    //     height: 100%;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     background: #fff;
    //     z-index: 999;
    // }
</style>